export default __webpack_public_path__ + "static/media/cari.327ee129.svg";